<template>
	<div>
		<template v-if="!editMode">
			<a-file-chip
				v-for="f in allFiles"
				:key="f.serverName"
				:file="f"
				:truncate="truncate"
				:max-width="maxWidth"
				:edit-mode="editMode"
			></a-file-chip>
		</template>
		<v-file-input
			v-else
			v-model="value"
			chips
			single-line
			prepend-icon=""
			:label="label"
			:accept="accept"
			:multiple="multiple"
			:rules="rules"
			:clearable="false"
			@change="onChange"
		>
			<template v-slot:selection="{ index, text }">
				<v-chip
					label
					close
					@click:close="delFile(index)"
				>
					<v-icon left>attach_file</v-icon>

					<div
						class="text-truncate"
						:style="style"
					>
						{{ text }}
					</div>
				</v-chip>
			</template>
		</v-file-input>
	</div>
</template>

<script>
import _ from 'lodash'
import aFileChip from './AFileChip.vue'

export default {
	components: {
		aFileChip
	},
	props: {
		files: {
			type: Array,
			default: () => []
		},
		uploadedFiles: {
			type: Array,
			default: () => []
		},
		editMode: Boolean,
		truncate: {
			type: Boolean,
			default: true
		},
		maxWidth: {
			type: Number,
			default: 360
		},
		multiple: {
			type: Boolean,
			default: true
		},
		label: {
			type: String,
			default: 'Загрузить файлы'
		},
		required: Boolean,
		formats: String,
		maxSize: String,
	},
	data: () => {
		return {
			initial: [],
			value: [],
		}
	},
	computed: {
		allFiles() {
			return this.uploadedFiles.concat(this.files)
		},
		style() {
			return 'max-width: ' + (this.maxWidth - 50) + 'px;'
		},
		accept() {
			if (!this.formats) return ''
			else return this.formats.split('|').map(f => '.' + f).join(', ')
		},
		rules() {
			const rules = []

			var rule

			if (this.required) {

				rule = v => {
					if (v !== null && v !== undefined && v.length > 0) return true
					else return 'Приложите файл'
				}

				rules.push(rule)
			}

			if (this.formats && this.formats.length) {
				let formats = this.formats.toLowerCase().split('|')

				rule = v => {
					for (let i in v) {
						if (v[i].name !== undefined) {
							let ext = v[i].name.split('.').pop().toLowerCase()
							if (formats.indexOf(ext) == -1) {
								return `Допустимые форматы: ${formats.join(', ')}`
							}
						}
					}
					return true
				}

				rules.push(rule)
			}

			if (+this.maxSize) {
				let max = +this.maxSize
				let mul = this.multiple

				rule = v => {
					for (let i in v) {
						if (v[i].size !== undefined) {
							let s = v[i].size / 1024 / 1024
							if (s > max) {
								return `Размер файла ${mul ? v[i].name : ''} составляет ${s.toFixed(2)} Mb и превышает максимальный - ${max} Mb`
							}
						}
					}
					return true
				}

				rules.push(rule)
			}

			return rules
		},
	},
	mounted() {
		this.value = this.allFiles
		this.initial = this.uploadedFiles
	},
	watch: {
		uploadedFiles: {
			deep: true,
			handler: function (val, old) {
				// console.log('watcher uploadedFiles', old, '=>', val)
				this.value = val
				this.initial = this.uploadedFiles
			}
		},
		files: {
			deep: true,
			handler: function (val, old) {
				// console.log('watcher files', old, '=>', val)
				this.value = this.uploadedFiles.concat(val)
			}
		}
	},
	methods: {
		onChange(e) {
			// console.log('onChange')
			if (!Array.isArray(e)) e = [ e ]

			if (!this.initial.length || !this.initial.every(i => {
				let serverNameSearch = i.serverName !== undefined && e.find(f => f.serverName == i.serverName) !== undefined
				let includeSearch = e.includes(i)

				return serverNameSearch || includeSearch
			})) {
				// console.log('initial', this.initial)
				// console.log('e', e)
				this.value = this.initial.concat(e)
				this.initial = this.value
				// console.log('value', this.value)
				this.$emit('update:files', this.excludeUploadedFiles(this.value))
			}
		},
		delFile(index) {
			this.initial = this.initial.filter((f, i) => i != index)
			this.value = this.value.filter((f, i) => i != index)
			let val = this.uploadedFiles.filter((f, i) => i != index)

			this.$emit('update:uploadedFiles', val)
			this.$emit('update:files', this.excludeUploadedFiles(this.value))
		},
		excludeUploadedFiles(files) {
			return files.filter(f => {
				return !this.uploadedFiles.includes(f)
			})
		},
	}
}
</script>

<style scoped lang="css">
</style>
